module.exports = __webpack_public_path__ + "img/futureisnow-poster.83b45f52.jpg";